import {EFileExtensions} from 'shared/constants/file-extensions';

export const SIGN_UPLOAD_EXTENSIONS = [
    EFileExtensions.P7S,
    EFileExtensions.SIG,
    EFileExtensions.SIGN,
    EFileExtensions.SGN,
    EFileExtensions.PKCS,
].toString();
